import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import { UploadResult } from './dto/UploadResult.dto';

// Централизованная загрузка медиа: файл заливается отдельным запросом,
// бэкенд отвечает { key, url }. key кладётся в форму сущности, url — для превью.
export class UploadApi {
  // eslint-disable-next-line no-unused-vars
  constructor(private api: ApiClient) {}

  async image(file: File): Promise<UploadResult> {
    const form = new FormData();
    form.append('image', file);
    const resp = await this.api.client.post<NiceResponse<UploadResult>>(
      '/upload/image',
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    if (!resp.data.body) {
      throw new Error('Не удалось загрузить изображение');
    }
    return resp.data.body;
  }

  // Бэкенд сам скачивает картинку по ссылке (только хосты GetCourse) и
  // перезаливает в S3 — используется при импорте урока из GetCourse.
  async imageByUrl(url: string): Promise<UploadResult> {
    const resp = await this.api.client.post<NiceResponse<UploadResult>>(
      '/upload/image-by-url',
      { url },
    );
    if (!resp.data.body) {
      throw new Error('Не удалось перекачать изображение');
    }
    return resp.data.body;
  }

  async audio(file: File): Promise<UploadResult> {
    const form = new FormData();
    form.append('audio', file);
    const resp = await this.api.client.post<NiceResponse<UploadResult>>(
      '/upload/audio',
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    );
    if (!resp.data.body) {
      throw new Error('Не удалось загрузить аудио');
    }
    return resp.data.body;
  }
}
